(function () {
  function getSelectedEvent() {
    try {
      const params = new URLSearchParams(window.location.search);
      const value = params.get('event');
      return value ? String(value) : null;
    } catch (error) {
      return null;
    }
  }

  function applyDetailView(section) {
    const selected = getSelectedEvent();
    if (!selected) return false;

    section.setAttribute('hidden', 'hidden');
    return true;
  }

  function initEventsGridLoadMore(root) {
    const scope = root || document;
    const sections = scope.querySelectorAll('[data-events-grid-load-more]');

    sections.forEach((section) => {
      if (section.dataset.loadMoreInit === 'true') return;
      section.dataset.loadMoreInit = 'true';

      if (applyDetailView(section)) return;

      const button = section.querySelector('[data-load-more-btn]');
      const cards = Array.from(section.querySelectorAll('[data-event-card]'));
      const hiddenCards = cards.filter((card) => card.hasAttribute('hidden'));

      if (!button || hiddenCards.length === 0) return;

      const increment = Number(section.dataset.loadIncrement) || 3;

      button.addEventListener('click', () => {
        if (hiddenCards.length === 0) return;

        const batch = hiddenCards.splice(0, increment);
        batch.forEach((card) => {
          card.removeAttribute('hidden');
          card.classList.add('events-grid__card--revealed');
        });

        if (hiddenCards.length === 0) {
          button.closest('[data-view-all-wrap]')?.setAttribute('hidden', 'hidden');
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initEventsGridLoadMore());

  document.addEventListener('shopify:section:load', (event) => {
    initEventsGridLoadMore(event.target);
  });
})();
